﻿(function () {
    var componentId = 'hostOperationsDashboardExpiredUnusedCheckInsDetail';
    var app = angular.module('app');

    function controller() {
        var vm = this;
        vm.clinicLocation = vm.resolve.clinicLocation;

        vm.close = function () {
            vm.modalInstance.dismiss();
        };
    }

    app.component(componentId, {
        templateUrl: require('/App/host/views/operationsDashboard/expiredUnusedCheckIns/detailModal.html'),
        bindings: {
            modalInstance: '<',
            resolve: '<'
        },
        controller: controller,
        controllerAs: 'vm'
    });
})();
